import { Icon } from '../../components/ui/Icon';
import styles from './music.module.css';

/** Square artwork with a graceful placeholder. */
export function Cover({ src, size = 48, radius, alt = '' }: { src: string | null | undefined; size?: number | string; radius?: number; alt?: string }) {
  return (
    <span className={styles.cover} style={{ width: size, height: size, borderRadius: radius ?? (typeof size === 'number' ? Math.max(6, size / 8) : 12) }}>
      {src ? <img src={src} alt={alt} loading="lazy" decoding="async" /> : <Icon name="note" size={typeof size === 'number' ? Math.max(16, size / 3) : 32} />}
    </span>
  );
}
